import React, { useEffect, useState } from 'react';
import { Privilege } from '../types/Privileges';
import { fetchPrivileges } from '../api/SecurityAPI';
import { logApiError } from '../api/apiError';

interface PrivilegesProps {
  token: string | null;
}

const PrivilegesComponent: React.FC<PrivilegesProps> = ({ token }) => {
  const [privileges, setPrivileges] = useState<Privilege[]>([]);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const loadPrivileges = async () => {
      try {    
        if (!token) return;
        const response = await fetchPrivileges(token);
        setPrivileges(response);
      } 
      catch (error) {
        logApiError(error);
        setError("Failed to load privileges.");
      }

    };

    loadPrivileges();
  }, [token]);

  if (error) {
    return <p className="status-error">{error}</p>;
  }

  return (
    <div>
      <h2 style={{ marginBottom: "1.5rem" }}>Privileges</h2>
      <ul className="privileges-list">
        {privileges.map((privilege) => (
          <li key={privilege.id}>
            <strong>{privilege.name}</strong>
            <span style={{ color: "var(--text-muted)", marginLeft: "0.5rem" }}>#{privilege.id}</span>
            {privilege.description && (
              <p style={{ margin: "0.5rem 0 0 0", color: "var(--text-secondary)", fontSize: "0.9375rem" }}>
                {privilege.description}
              </p>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default PrivilegesComponent;
